import React from "react";

export const actions = {
    SELECTED: 'selected',
    DESELECTED: 'deselected',
    HIDE_INFO: 'hide_info',
    SELECT_ORG: 'select_org',
}


export function mapReducer(state, action) {
    switch (action.type) {
        case actions.SELECTED: {
            return {
                ...state,
                selected: action.data,
                showInfo: true,
            };
        }
        case actions.DESELECTED: {
            return {
                ...state,
                selected: null,
            };
        }
        case actions.HIDE_INFO: {
            return {
                ...state,
                showInfo: false,
            }
        }
        case actions.SELECT_ORG: {
            return {
                ...state,
                ...action.data
            }
        }
        default: {
            throw Error('Unknown action: ' + action.type);
        }
    }
}

export const initialMapState = {
    selected: null,
    showInfo: false,
    selectedOrg: null
}

export default function MapReducer() {
    const [{selected, showInfo, selectedOrg}, dispatch] = React.useReducer(mapReducer, initialMapState)
    
    const onCountyClick = (data) => dispatch({
        type: actions.SELECTED,
        data
      });
    
    const handleClose = () => dispatch({
        type: actions.DESELECTED,
    });
    const hideInfo = () => dispatch({type: actions.HIDE_INFO})
    const selectOrg = (selectedOrg) => dispatch({type: actions.SELECT_ORG, data: {selectedOrg}})
    return {
        selected,
        showInfo,
        selectedOrg,
        onCountyClick,
        handleClose,
        hideInfo,
        selectOrg,
    }
}